import {
  abs,
  bignumber,
  isComplex,
  isConstantNode,
  MathNode,
  random
} from "mathjs";

import { getVariables } from "../operations";
import { applyImplicitMultiplications } from "./structEqual";

export function funcEqual(originalA: MathNode, originalB: MathNode): boolean {
  if (oneInputIsEmpty(originalA, originalB)) {
    return false;
  }
  const a = applyImplicitMultiplications(originalA);
  const b = applyImplicitMultiplications(originalB);
  const aVariables = getVariables(a);
  const bVariables = getVariables(b);

  if (
    aVariables.length !== bVariables.length ||
    aVariables.some(symbol => !bVariables.includes(symbol))
  ) {
    return false;
  }

  const aCompiled = a.compile();
  const bCompiled = b.compile();

  for (let i = 0; i < 100; i++) {
    const scope = aVariables.reduce(
      (acc, symbol) => ({
        ...acc,
        [symbol]: bignumber(random(-1000, 1000))
      }),
      {}
    );

    const aEvaluated = aCompiled.evaluate(scope);
    const bEvaluated = bCompiled.evaluate(scope);

    if (isComplex(aEvaluated) && isComplex(bEvaluated)) {
      return aEvaluated.equals(bEvaluated);
    }
    if (isComplex(aEvaluated) || isComplex(bEvaluated)) {
      return false;
    }
    const aResult = bignumber(aCompiled.evaluate(scope));
    const bResult = bignumber(bCompiled.evaluate(scope));

    if (
      !isNaN(aResult) &&
      !isNaN(bResult) &&
      abs(aResult - bResult) > 0.00001
    ) {
      return false;
    }
  }

  return true;
}

function oneInputIsEmpty(a: MathNode, b: MathNode) {
  return (
    (isConstantNode(a) && (a.value === undefined || isNaN(a.value))) ||
    (isConstantNode(b) && (b.value === undefined || isNaN(b.value)))
  );
}
